module.exports = __webpack_public_path__ + "static/half_sheet-2c01c9b791878713d420496530e19fe0.png";